/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class EnableAccountSuccess extends React.Component<*> {
  componentDidMount() {
    const details: Object =
      this.props.accountStore.details && this.props.accountStore.details.details;
    details.is_enabled = true; // eslint-disable-line camelcase
  }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:trading_accounts.enabled')}</h3>
            <p>{t('general:trading_accounts.messages.enabled')}</p>
          </div>
          <div className={styles['enable-account-details']}>
            <React.Fragment>
              <ul>
                {
                  <li>
                    {/* <b>{t('general:trading_account')}: </b> */}
                    {actionDrawerStore.response.name}
                  </li>
                }
                {
                  <li>
                    {/* <b>{t('general:trading_accounts.labels.number')}: </b> */}
                    {actionDrawerStore.response.account_no}
                  </li>
                }
              </ul>
            </React.Fragment>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
